// src/pages/Home/index.jsx
import React, { useState, useEffect } from 'react';
import PostCard from '../../component/PostCard/index.jsx';
import { useAuth } from '../../context/AuthContext';
import { EditOutlined, BookOutlined, CoffeeOutlined } from '@ant-design/icons';
import './index.css';

const Home = () => {
  const [posts, setPosts] = useState([]);
  const { getAllPosts, isAuthenticated } = useAuth();

  useEffect(() => {
    // 获取所有文章，按日期倒序排列
    const allPosts = getAllPosts();
    const sortedPosts = [...allPosts].sort((a, b) => 
      new Date(b.date) - new Date(a.date)
    );
    setPosts(sortedPosts);
  }, [getAllPosts]);

  return (
    <div className="home-page">
      <div className="hero-section">
        <div style={{ fontSize: '3.5rem', marginBottom: '1rem' }}>✨</div>
        <h1>欢迎来到我的博客</h1>
        <p>📚 分享技术、记录生活、思考人生</p>
        <div style={{ marginTop: '1.5rem', display: 'flex', justifyContent: 'center', gap: '1rem', flexWrap: 'wrap' }}>
          <div style={{ display: 'flex', alignItems: 'center', color: '#0d9488' }}>
            <BookOutlined style={{ marginRight: '6px' }} /> {posts.length} 篇文章
          </div>
          <div style={{ display: 'flex', alignItems: 'center', color: '#f97316' }}>
            <CoffeeOutlined style={{ marginRight: '6px' }} /> 持续创作中
          </div>
        </div>
      </div>
      
      <div className="posts-section">
        <h2>📰 最新文章</h2>
        {posts && posts.length > 0 ? (
          posts.map(post => (
            <PostCard key={post.id} post={post} />
          ))
        ) : (
          <div style={{ textAlign: 'center', padding: '3rem', background: 'white', borderRadius: '16px', border: '1px solid #e0f2fe' }}>
            <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>📖</div>
            <p style={{ color: '#67e8f9', fontSize: '1.2rem', marginBottom: '1rem' }}>还没有文章呢</p>
            <p style={{ color: '#1e3a8a', fontSize: '1rem' }}>
              {isAuthenticated ? (
                <>
                  <EditOutlined style={{ marginRight: '6px' }} />
                  <a 
                    href="/write" 
                    style={{ color: '#0ea5e9', textDecoration: 'none', fontWeight: '500' }}
                    onClick={(e) => {
                      e.preventDefault();
                      window.location.href = '/write';
                    }}
                  >
                    立即撰写第一篇文章
                  </a>
                </>
              ) : (
                <>
                  <a 
                    href="/auth" 
                    style={{ color: '#0ea5e9', textDecoration: 'none', fontWeight: '500' }}
                    onClick={(e) => {
                      e.preventDefault();
                      window.location.href = '/auth';
                    }}
                  >
                    登录
                  </a> 后即可开始创作
                </>
              )}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Home;